import * as v from "valibot";
import { BaseRecordSchema, baseVals, defineValidation, listVals } from "../../common/validation.common";

export namespace PrivilegeValidation {
    export const Record = defineValidation(BaseRecordSchema);

    export const Create = defineValidation(
        v.object({
            name: baseVals.string(),
            description: v.optional(baseVals.string()),
            privileges: listVals.stringList("Hak Akses"),
        }),
    );

    export const Update = defineValidation(
        v.object({
            name: v.exactOptional(baseVals.string()),
            description: v.exactOptional(baseVals.string()),
            privileges: v.exactOptional(listVals.stringList("Hak Akses")),
        }),
    );
}
